<template>
  <div class="bg-white m-3">
    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>
    <section class="flex justify-between">
      <!-- {{ filteredLeavesBalances }} -->
      <div class="flex items-left my-2 mb-3 gap-8">
        <el-pagination
          background
          layout="sizes"
          @size-change="pageSizeChange"
        />
        <input
          type="search"
          v-model="searchInput"
          placeholder="Start typing to search..."
          class="bg-gray-200 w-52 py-2 rounded-md"
        />
      </div>
      <div class="flex items-left my-2 mb-3 mr-3 gap-2">
        <!-- {{ periods }} -->
        <select
          v-model="selectedYear"
          placeholder="Select period"
          class="w-full bg-gray-200"
        >
          <option
            v-for="period in periods"
            :key="period.Id"
            :label="period.PeriodName.toString()"
            :value="period.Id"
            @on-select="handlePeriodChange()"
          ></option>
        </select>
        <button
          @click="showExportOptions = true"
          class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
          style="
            justify-items: center;
            align-items: center;
            justify-content: center;
          "
        >
          <img class="h-5" src="@/assets/icons/export-excel.png" />
          Export
        </button>
      </div>
    </section>
    <div class="">
      <!-- {{ filteredLeavesBalances }} -->
      <el-tabs
        type="border-card"
        :tab-position="tabPosition"
        class="text-left"
        v-model="activeTab"
      >
        <el-tab-pane
          v-for="leave in leaveTypes"
          :key="leave.Id"
          :label="leave.Name"
          :name="leave.Name"
          style="text-align: left !important"
        >
          <ve-table
            :max-height="500"
            :columns="columns"
            :table-data="tableData"
            row-key-field-name="Id"
            :sort-option="sortOption"
          />
          <div
            class="flex flex-col justify-center items-center h-full mt-5"
            v-if="tableData.length === 0"
          >
            <el-empty :image-size="70" description="No Data"></el-empty>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- <div
        class="table-pagination bottom-0 mx-auto flex items-center justify-center"
      >
        <el-pagination
          layout="prev, pager, next"
          :total="totalCount"
          :page-index="pageIndex"
          :page-size="pageSize"
          @on-page-number-change="pageNumberChange"
        />
      </div> -->
    </div>
    <ExportOptions
      :show-export-options="showExportOptions"
      :leave-names="leaveNames"
      :activeLeaveName="activeTab"
      :exportLeaveDatacallBack="exportLeaveDatacallBack"
      :close="close"
    ></ExportOptions>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import ExportOptions from "./exportOptions.vue";
import { debounce } from "lodash";
import { utils, writeFileXLSX } from "xlsx";
import decryptData from "@/utils/decrypt";

export default {
  name: "TimeoffBalances",
  components: { Loader, ExportOptions },
  data() {
    return {
      periods: [],
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      searchInput: null,
      showExportOptions: false,
      leaveNames: [],
      activeTab: "",
      tabPosition: "left",
      pageIndex: 1,
      pageSize: 10,
      selectedYear: null,
      years: [],
      leaveTypes: [],
      get_error: null,
      loading: false,
      leaves: [],

      leaveTypeIds: [],
      filteredLeavesBalances: null,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "left",
          headerAlign: "left",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "EmployeeNo",
          key: "EmployeeNo",
          title: "Employee No",
          align: "left",
          width: "15%",
        },
        {
          field: "EmployeeName", // Updated field name
          key: "EmployeeName", // Updated key
          title: "Employee Name", // Updated title
          align: "left",
          width: "15%",
        },

        {
          field: "BroughtForward", // Updated field name
          key: "BroughtForward", // Updated key
          title: "Brought Forward", // Updated title
          align: "center",
          width: "15%",
        },
        {
          field: "TakeOn", // Updated field name
          key: "TakeOn", // Updated key
          title: "Take On", // Updated title
          align: "center",
          width: "8%",
        },
        {
          field: "Entitled",
          key: "Entitled",
          title: "Entitled",
          align: "center",
          width: "8%",
        },
        {
          field: "Earned",
          key: "Earned",
          title: "Earned",
          align: "center",
          width: "8%",
        },
        {
          field: "Consumed",
          key: "Consumed",
          title: "Consumed",
          align: "center",
          width: "10%",
          sortBy: "asc",
        },
        {
          field: "Available",
          key: "Available",
          title: "Available",
          align: "center",
          width: "10%",
          sortBy: "asc",
        },
      ],
    };
  },

  mounted() {
    this.handleResize();

    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    this.getPeriods();
  },
  watch: {
    tabPosition() {
      this.getLeaves();
    },
    selectedYear() {
      this.getLeaves();
    },
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),

    tableData() {
      // const { pageIndex, pageSize } = this;
      const data = this.filteredLeavesBalances[this.activeTab];
      // .slice(
      //   (pageIndex - 1) * pageSize,
      //   pageIndex * pageSize
      // );

      if (!this.searchInput) {
        return data;
      } else {
        const searchInputLower = this.searchInput.toLowerCase();
        return this.filteredLeavesBalances[this.activeTab].filter((item) => {
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },

    totalCount() {
      return this.filteredLeavesBalances[this.activeTab].length;
    },
  },

  methods: {
    handlePeriodChange() {},
    close() {
      this.showExportOptions = false;
    },
    async getPeriods() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/setup/leave/period/${this.$ApiVersion}/request`,
          options
        );

        this.loading = false;

        if (response.data.StatusCode === 200) {
          this.periods = response.data.Data.filter(
            (p) => p.PeriodName != "Test"
          ).sort((a, b) => a.PeriodName < b.PeriodName);
          this.getLeaveTypes();
          console.log(this.periods)
          this.selectedYear = this.periods[0].Id;
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },

    async getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/request`,
          options
        );

        this.loading = false;

        if (response.data.StatusCode === 200) {
          this.leaveTypes = response.data.Data;
          this.leaveTypeIds = this.leaveTypes.map((leave) => leave.Id);
          this.leaveNames = this.leaveTypes.map((leave) => leave.Name);
          this.activeTab = this.leaveNames[0];
          if (this.leaveNames.length && this.leaveTypeIds.length) {
            await this.getLeaves();
          }
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },

    async getLeaves() {
      this.loading = true; // Set loading to true before making the requests
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
        },
      };

      try {
        // Fetch leaves for all leave types in parallel
        const responses = await Promise.all(
          this.leaveTypeIds.map((leaveId) =>
            axios.get(
              `${this.getOrganization}/timeoff/members/${this.$ApiVersion}/summary?type=${leaveId}&periodId=${this.selectedYear}`,
              options
            )
          )
        );

        // Combine and decrypt data from all responses
        this.leaves = responses.flatMap((response) => {
          if (response.data.StatusCode === 200) {
            return response.data.Data.map((row) => ({
              ...row,
              EmployeeName: decryptData(row.EmployeeName, this.$decryptionKey),
            }));
          } else {
            this.$notify.error({
              title: "Failure",
              message: `Something went wrong: ${response.data.StatusMessage}`,
            });
            this.get_error = response.data.StatusMessage;
            return []; // Return an empty array for failed responses to maintain structure
          }
        });

        // Filter leaves and create the desired data structure
        this.filteredLeavesBalances = {};
        this.filterLeaves();
      } catch (error) {
        this.$notify.error({
          title: "Failure",
          message: `Something went wrong: ${error.message}`,
        });
        this.get_error = error.message;
      } finally {
        this.loading = false; // Set loading to false after all promises are resolved
      }
    },
    filterLeaves() {
      this.leaveNames.forEach((leaveName) => {
        const filteredLeaves = this.leaves
          .filter((leave) => leave.Timeofftype.includes(leaveName))
          .map(({ Summary, ...rest }) => ({
            ...rest,
            ...Summary,
          }));

        this.filteredLeavesBalances[leaveName] = filteredLeaves;
      });
      this.loading = false;
    },

    exportData(leaveNames, selectedEmployeeNumber) {
      const wb = utils.book_new();
      leaveNames.forEach((leaveName) => {
        let leaveData = this.filteredLeavesBalances[leaveName];

        if (selectedEmployeeNumber) {
          leaveData = leaveData.filter(
            (leave) => leave.EmployeeNo == selectedEmployeeNumber
          );
        }
        const ws = utils.json_to_sheet(leaveData);
        utils.book_append_sheet(wb, ws, leaveName);
      });

      writeFileXLSX(
        wb,
        `${
          leaveNames.length <= 1
            ? `${leaveNames[0]} Balances`
            : "Leave Balances"
        }.xlsx`
      );
    },
    exportLeaveDatacallBack(data, selectedEmployeeNumber) {
      this.exportData(data, selectedEmployeeNumber);
    },

    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },

    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    handleResize: debounce(function () {
      this.tabPosition = window.innerWidth < 668 ? "top" : "left";
    }, 300),

    sortChange(params) {
      this.tableData.sort((a, b) => {
        if (params.Consumed) {
          if (params.Consumed === "asc") {
            return a.Consumed - b.Consumed;
          } else if (params.Consumed === "desc") {
            return b.Consumed - a.Consumed;
          } else {
            return 0;
          }
        } else if (params.Available) {
          if (params.Available === "asc") {
            return a.Available - b.Available;
          } else if (params.Available === "desc") {
            return b.Available - a.Available;
          } else {
            return 0;
          }
        }
      });
    },
  },
};
</script>

<style>
.el-col-offset-0,
.el-tabs--border-card
  > .el-tabs__header
  .is-scrollable
  .el-tabs__item:first-child {
  margin-left: 0;
}
.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
  border: 1px solid transparent;
  margin: -1px 0 -1px -1px;
  margin-left: -1px;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item + .el-tabs__item,
.el-tabs--border-card > .el-tabs__header .el-tabs__item:first-child {
  margin-left: -1px;
}
.el-tabs--left .el-tabs__item.is-left {
  text-align: left !important;
}
.el-tabs--left .el-tabs__item.is-left,
.el-tabs--left .el-tabs__item.is-right,
.el-tabs--right .el-tabs__item.is-left,
.el-tabs--right .el-tabs__item.is-right {
  display: block;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px solid transparent;
  margin-top: -1px;
  color: #909399;
}
.el-tabs__item {
  padding: 0 20px;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  position: relative;
}

.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left.is-active {
  border-color: #d1dbe5 transparent;
  background-color: darkgoldenrod !important;
  color: #fff;
}

.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left:hover {
  border-color: #d1dbe5 transparent;
  background-color: darkgoldenrod !important;
  color: #fff;
}
.el-tabs--border-card {
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: none;
}

.el-tabs--left .el-tabs__header.is-left {
  float: left;
  margin-bottom: 0;
  margin-right: 0 !important;
  height: 100vh;
}

.el-input.el-input--mini.el-input--suffix .el-input__inner {
  height: 31px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0 !important;
  /* width: 11.1rem; */
}
</style>
